export const HEADER_STYLES = {
  container: 'min-h-10 bg-bg-2 border-b flex items-center',
  padding: 'px-2', // 8px horizontal padding
  textBase: 'text-sm font-mono text-text-50/70',
} as const;
